import { render, staticRenderFns } from "./FormPasswordResetProfessional.vue?vue&type=template&id=775f4620"
import script from "./FormPasswordResetProfessional.vue?vue&type=script&lang=js"
export * from "./FormPasswordResetProfessional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports